/**
 * ? @description : Pre-Requisite Information Component
 */

// Dependencies
import React from "react";
import { Form } from "react-bootstrap";
import {
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

export default function PrereqInfo({
  formData,
  setFormData,
  validationRes,
  setValidationRes,
}) {
  const today = new Date();
  const maxDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
  return (
    <div>
      <Form>
        <Box>
          <FormControl>
            <FormLabel id="have_student_already">
              Do you already have a student ?&nbsp;
              <span style={{ color: "red" }}>*</span>
              <p style={{ color: "gray", fontSize: "12px" }}>
                Note : If yes, You will be redirect to student waitlist form after successful completion
              </p>
            </FormLabel>
            <RadioGroup
              aria-labelledby="have_student_already"
              name="controlled-radio-buttons-group"
              value={formData.have_student_already}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  have_student_already: event.target.value,
                });
                setValidationRes({
                  ...validationRes,
                  isInvalidHaveStudentAlready: false,
                });
              }}
            >
              <FormControlLabel value="true" control={<Radio />} label="Yes" />
              <FormControlLabel value="false" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>
        </Box>

        <Form.Group className="mb-3 form-info">
          <Form.Label>
            Tentative Start Date <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <Form.Control
            type="date"
            name="tentative_start_date"
            style={{ width: "250px" }}
            min={today.toISOString().split("T")[0]}
            max={maxDate.toISOString().split("T")[0]}
            value={formData.tentative_start_date}
            onKeyDown={(e) => e.preventDefault()}
            onChange={(event) => {
              setFormData({
                ...formData,
                tentative_start_date: event.target.value,
              });
              setValidationRes({ ...validationRes, isInvalidStartDate: false });
            }}
            isInvalid={validationRes.isInvalidStartDate}
          />

          <Form.Control.Feedback type="invalid">
            Date is mandatory.
          </Form.Control.Feedback>
        </Form.Group>
      </Form>
    </div>
  );
}
